










































































































































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		//date presume grossesse
		dpg: {
			type: String,
			default: ''
		},
		moisgrossesse: {
			type: Number,
			default: 1
		},
		height: {
			type: Number,
			default: 330
		}
	},
	data: function() {
		return {
			isDisplayAfficherMoins: false,
			isDisplayAfficherPlus: true,
			maxHeight: this.height + 'px',
			minHeight: this.height + 'px'
		};
	},
	watch: {
		moisgrossesse: function(newVal, oldVal) {
			this.maxHeight = this.height + 'px';
			this.minHeight = this.height + 'px';
		}
	},
	mounted() {
		this.afficherBoutonPlusOuMoins();
	},
	updated() {
		this.updatedBoutonPlusOuMoins();
	},
	created() {
		window.addEventListener('resize', this.afficherBoutonPlusOuMoins);
	},
	methods: {
		afficherMoins: function() {
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.maxHeight = this.height + 'px';
		},
		afficherPlus: function() {
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.maxHeight = 'inherit';
		},
		updatedBoutonPlusOuMoins: function() {
			if (window.innerWidth > 760) {
				if (this.height >= (this.$refs.VCardRdvMedicaux as Vue).$el.scrollHeight) {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
					this.maxHeight = this.height + 'px';
				} else {
					if (this.maxHeight == 'inherit') {
						this.isDisplayAfficherMoins= true;
						this.isDisplayAfficherPlus= false;
					} else {
						this.isDisplayAfficherMoins= false;
						this.isDisplayAfficherPlus= true;
					}
				}
			}
		},
		afficherBoutonPlusOuMoins: function() {
			if (window.innerWidth < 760) {
				this.minHeight = 'inherit';
				this.maxHeight = 'inherit';
				this.isDisplayAfficherMoins= false;
				this.isDisplayAfficherPlus= false;
			} else {
				this.minHeight = this.height + 'px';
				this.maxHeight = this.height + 'px';
				if (this.height >= (this.$refs.VCardRdvMedicaux as Vue).$el.scrollHeight) {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
				} else {
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= true;
				}
			}
		},
		getDateEchographieDebut: function(numeroEchographie: Number) {
			var date:Date = new Date(+this.dpg.substring(0,4), +this.dpg.substring(4,6)-1, +this.dpg.substring(6,8));
			switch (numeroEchographie) {
				case 1: {
					date.setDate(date.getDate() + 56);
					break;
				}
				case 2: {
					date.setDate(date.getDate() + 119);
					break;
				}
				case 3: {
					date.setDate(date.getDate() + 189);
					break;
				}
			}
			return new Intl.DateTimeFormat().format(date);
		},
		getDateEchographieFin: function(numeroEchographie: Number) {
			var date:Date = new Date(+this.dpg.substring(0,4), +this.dpg.substring(4,6)-1, +this.dpg.substring(6,8));
			switch (numeroEchographie) {
				case 1: {
					date.setDate(date.getDate() + 82);
					break;
				}
				case 2: {
					date.setDate(date.getDate() + 160);
					break;
				}
				case 3: {
					date.setDate(date.getDate() + 230);
					break;
				}
			}
			return new Intl.DateTimeFormat().format(date);
		}
	}
});

@Component
export default class RendezVousMedicaux extends Props {
}
